module.exports = __webpack_public_path__ + "img/New_DeliveryB2B__Branco_Horizontal.129037d8.png";